/* Injetar cores no CSS como variável
 *
 * Importar o objeto ou constante de cores
 * em injectColors utilizar o setProperty para injetar no Css setStyle.setProperty("--nome var css", valor da cor);
 */
import {
    primary,
    secondary,
    grayScale,
    warnings,
    white
} from './colors'


const injectColors = () => {

    const setStyle = document.documentElement.style;

    // Branco
    setStyle.setProperty("--white100", white);

    // Primárias
    setStyle.setProperty("--primary100", primary.primary100);
    setStyle.setProperty("--primary200", primary.primary200);
    setStyle.setProperty("--primary300", primary.primary300);

    //Secundárias 
    setStyle.setProperty("--secondary100", secondary.secondary100);
    setStyle.setProperty("--secondary200", secondary.secondary200);

    // Escala de Cinza 
    setStyle.setProperty("--gray100", grayScale.gray100);
    setStyle.setProperty("--gray200", grayScale.gray200);
    setStyle.setProperty("--gray300", grayScale.gray300);
    setStyle.setProperty("--gray400", grayScale.gray400);

    // Avisos
    setStyle.setProperty("--error", warnings.error);
    setStyle.setProperty("--success", warnings.success);
    setStyle.setProperty("--warning", warnings.warning);
}

export default injectColors